import React from 'react';
import { styled } from '@mui/material/styles';
import { SvgIcon } from '../../../types/SvgIcon';
import { ICON_SIZES } from '../../../components/Icon/const';
import SnackbarErrorIcon from './icons/SnackbarErrorIcon';
import SnackbarWarningIcon from './icons/SnackbarWarningIcon';
import SnackbarSuccessIcon from './icons/SnackbarSuccessIcon';
import SnackbarInfoIcon from './icons/SnackbarInfoIcon';

type Severity = 'error' | 'warning' |'success' | 'info';

export const icons: { [key in Severity]: SvgIcon } = {
  error: SnackbarErrorIcon,
  warning: SnackbarWarningIcon,
  success: SnackbarSuccessIcon,
  info: SnackbarInfoIcon,
};

interface Props {
  severity: Severity;
  fontSize?: number;
}

const StyledIcon = (icon: SvgIcon, fontSize?: number) => styled(icon)(
  ({ theme }) => ({
    '&.error': {
      height: fontSize,
      width: fontSize,
      '& .outline': {
        fill: theme.palette.error.outlineVariant,
      },
      '& .background': {
        fill: theme.palette.error.main,
      },
      '& .content': {
        fill: theme.palette.error.onMain,
      }
    },
    '&.warning': {
      height: fontSize,
      width: fontSize,
      '& .outline': {
        fill: theme.palette.warning.outlineVariant,
      },
      '& .background': {
        fill: theme.palette.warning.main,
      },
      '& .content': {
        fill: theme.palette.warning.onMain,
      }
    },
    '&.success': {
      height: fontSize,
      width: fontSize,
      '& .outline': {
        fill: theme.palette.success.outlineVariant,
      },
      '& .background': {
        fill: theme.palette.success.main,
      },
      '& .content': {
        fill: theme.palette.success.onMain,
      }
    },
    '&.info': {
      height: fontSize,
      width: fontSize,
      '& .outline': {
        fill: theme.palette.info.outlineVariant,
      },
      '& .background': {
        fill: theme.palette.info.main,
      },
      '& .content': {
        fill: theme.palette.info.onMain,
      }
    }
  })
);

const SeverityIcon = ({ severity, fontSize = ICON_SIZES.MEDIUM }: Props) => {
  const Icon = StyledIcon(icons[severity], fontSize);
  return (
    <Icon className={severity} data-test-id='severity-icon' />
  );
};

export default SeverityIcon;